import { withStyles } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { useTranslations } from "../../../adapters/i18n";
import * as action from "../../../redux/actions";
import { useLogin } from "../hooks/useLogin";
import styles from "./styles";

export const LoginPage = ({ classes, exibirCarregando, notifyError }) => {
  const { t } = useTranslations();

  const {
    passwordVisibility,
    error,
    handleShowPassword,
    navigateToForgotPassword,
    onSubmit,
  } = useLogin({ exibirCarregando, notifyError });

  return (
    <div className={classes.container}>
      <div className={classes.loaderWrapper}>
        <div className={classes.loader}></div>
      </div>
      <div className={classes.loginPage}>
        <div className={classes.loginForm}>
          <header>
            <div className={classes.logoWrapper}>
              <img
                className={classes.logoWrapperImg}
                src="https://storage.googleapis.com/armazenamento-imagens/logo/logo-Farmtell-Views-Cor.svg"
                alt=""
              />
            </div>

            <div className={classes.greetings}>
              <h1 className={classes.greetingWelcome}>{t("login:welcome")}</h1>
              <p className={classes.greetingTitle}>{t("login:log-in")}</p>
            </div>
          </header>

          <form className={classes.form} onSubmit={onSubmit}>
            <div
              className={[
                classes.inputWrapper,
                error ? classes.onError : "",
              ].join(" ")}
            >
              <label className={classes.formControlLabel} htmlFor="username">
                {t("common:fields.user")}
              </label>
              <input
                className={classes.loginInput}
                type="text"
                name="username"
                placeholder={t("login:enter-username")}
              />
              <div className={classes.icon}>
                <img
                  width="14px"
                  height="15px"
                  src="https://storage.googleapis.com/armazenamento-imagens/assets/username-new-blue.svg"
                  alt=""
                />
              </div>
            </div>
            <div
              className={[
                classes.inputWrapper,
                error ? classes.onError : "",
              ].join(" ")}
            >
              <label className={classes.formControlLabel} htmlFor="password">
                {t("login:password")}
              </label>
              <input
                className={classes.loginPasswordInput}
                type={passwordVisibility ? "text" : "password"}
                name="password"
                placeholder={t("login:enter-your-password")}
              />
              <div
                className={classes.icon}
                data-testid={"show-password-icon"}
                onClick={handleShowPassword}
              >
                {passwordVisibility ? (
                  <img
                    data-testid={"visibilityOn"}
                    width="16px"
                    height="17px"
                    src="https://storage.googleapis.com/armazenamento-imagens/assets/visibility-on-new-blue.svg"
                    alt="visibilityOn"
                  />
                ) : (
                  <img
                    data-testid={"visibilityOff"}
                    width="16px"
                    height="17px"
                    src="https://storage.googleapis.com/armazenamento-imagens/assets/visibility-off-new-blue.svg"
                    alt="visibilityOff"
                  />
                )}
              </div>
            </div>

            <div className={classes.forgotPasswordWrapper}>
              <span
                className={classes.forgotPasswordLink}
                onClick={navigateToForgotPassword}
              >
                {t("login:forgot-password")}
              </span>
            </div>

            <button className={classes.loginButton} type="submit">
              {t("login:sign-in")}
            </button>
          </form>
        </div>

        <div className={classes.bgOxWrapper}></div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  exibirCarregando: action.exibirCarregando,
  notifyError: action.notifyError,
};

export default compose(
  connect(null, mapDispatchToProps),
  withStyles(styles)
)(LoginPage);
